import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { RobotArrivedDesktopViewStyles as useStyles } from '../styles';
import CountdownTimer from './CountdownTimer';
import MapContainer from './MapContainer';
import RobotDeliverySteps from '../../../../../components/RobotDeliverySteps';
import { AuthorizedParcel } from '../../../../../types/Parcel';

type Props = {
  parcel: AuthorizedParcel,
  showMap: boolean,
};

const RobotArrivedDesktopView = ({ parcel, showMap }: Props) => {
  const bottomComponentRef = React.useRef({});
  const styles = useStyles({
    footerHeight: bottomComponentRef.current.clientHeight,
  });

  const robotName = parcel.parcelStatusInfo.robotName;
  const [robotLeavingTime, setRobotLeavingTime] = useState(null);

  useEffect(() => {
    const leavingTime = parcel.parcelStatusInfo.robotLeavingTime;
    setRobotLeavingTime(leavingTime);
  }, []);

  return (
    <div className={styles.wrapper}>
      <Grid container direction="column" className={styles.mainContainer}>
        <Grid item xs={12} className={styles.titleContainer}>
          <Typography className={styles.deliveryInfo}>
            Your delivery robot, {robotName}, has arrived.
          </Typography>
        </Grid>
        <Grid item xs={12} className={styles.titleContainer}>
          <Typography className={styles.deliveryInfo}>
            Time remaining to collect parcel:
          </Typography>
          <CountdownTimer targetTime={robotLeavingTime} />
        </Grid>

        <Grid
          container
          direction="row"
          className={styles.stepsAndMapContainer}
          spacing={2}
        >
          <Grid item xs={12} md={6} className={styles.mapContainer}>
            <MapContainer showMap parcel={parcel} size="410*549" />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            container
            direction="column"
            justify="space-around"
            alignItems="center"
            className={styles.container}
            ref={bottomComponentRef}
          >
            <RobotDeliverySteps robotName={robotName} noBreaks />
          </Grid>
        </Grid>

        <Grid container direction="row" className={styles.logoWithETAContainer}>
          <Grid
            container
            direction="column"
            justify="space-around"
            className={styles.progressContainer}
          >
            <Grid item className={styles.bottomLine} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default RobotArrivedDesktopView;
